import React, { useState } from 'react';
import './Reset.css';
import axios from 'axios';
import { serverUrl } from '../../../../Constant/Static/config';
import Header from '../../../Registration/Header';
import peopleIcon from '../../../../Constant/Icons/people.svg';
import userName from '../../../../Constant/Icons/username.svg';
import passwordIcon from '../../../../Constant/Icons/password.svg';
import eyeIcon from '../../../../Constant/Icons/eye.svg';
import user from '../../../../Constant/Icons/user.svg';
import eyeSlashIcon from '../../../../Constant/Icons/eyehide.svg';
import PopModal from '../../../../Constant/Custom/Models/PopModal';
import { useNavigate } from 'react-router-dom';

const CollegeResetPassword = () => {
  const [formData, setFormData] = useState({
    collegeCode: '',
    newPassword: '',
  });
  const [showPassword, setShowPassword] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalType, setModalType] = useState({ title: '', text: '', icon: '' });
  const navigate = useNavigate();

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  const handlePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.collegeCode || !formData.newPassword) {
      setModalType({
        icon: 'warning',
        title: 'Invalid Input',
        text: 'College code and new password cannot be empty.',
      });
      openModal();
      return;
    }

    const dataToSend = {
      collegeCode: formData.collegeCode.trim(),
      newPassword: formData.newPassword.trim(),
    };

    try {
      const response = await axios.post(`${serverUrl}/api/college/reset-password`, dataToSend);
      if (response.status === 200) {
        setModalType({
          icon: 'success',
          title: 'Password Reset Successful!',
          text: response.data.message,
        });
        openModal();
        setTimeout(() => {
          navigate('/college-login');
        }, 2000); 
      }
    } catch (err) {
      const errorMessage = err.response?.data?.message || 'An error occurred. Please try again.';
      setModalType({
        icon: 'error',
        title: 'Password Reset Failed!',
        text: errorMessage,
      });
      openModal();
    }
  };

  const handleCancel = () => {
    setFormData({
      collegeCode: '',
      newPassword: '',
    });
    closeModal();
  };

  return (
    <div style={{ width: '100dvw', height: '100dvh', backgroundColor: '#f9f9f9' }}>
      
      <Header>
        <a href="/college-login">
          <img src={user} alt="Login" width={50} height={50} />
        </a>
      </Header>
       <h1 style={{textAlign:"center"}}>RESET PASSWORD</h1>
      <div className="reset-password-container">
        <div className="reset-password-inner-container">
          <img src={peopleIcon} alt="user" width={75} height={75} />
          <form onSubmit={handleSubmit}>
            <div className="reset-password-form-group">
              <input
                type="text"
                name="collegeCode"
                value={formData.collegeCode}
                placeholder="Enter College Code"
                onChange={handleChange}
                required
              />
              <img className="IconForInput" src={userName} alt="user" width={20} height={20} />
            </div>
            <div className="reset-password-form-group">
              <input
                type={showPassword ? 'text' : 'password'}
                name="newPassword"
                value={formData.newPassword}
                placeholder="Enter New Password"
                onChange={handleChange}
                required
              />
              <img className="IconForInput" src={passwordIcon} alt="password" width={20} height={20} />
              <button
                type="button"
                className="toggle-password"
                onClick={handlePasswordVisibility}
                aria-label={showPassword ? 'Hide Password' : 'Show Password'}
              >
                <img src={showPassword ? eyeSlashIcon : eyeIcon} alt="toggle password visibility" width={20} height={20} />
              </button>
            </div>
            <div className="reset-password-form-group">
              <button type="submit" className="reset-password-button">Reset Password</button>
            </div>
          </form>
          <div
            style={{
              position: 'relative',
              alignSelf: 'center',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <svg
              height={10}
              width="100%"
              xmlns="http://www.w3.org/2000/svg"
            >
              <line
                x1="0%"
                y1="55%"
                x2="100%"
                y2="55%"
                style={{
                  stroke: '#1C274C',
                  strokeWidth: 0.25,
                  filter: 'drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.25))',
                }}
              />
            </svg>
            <div
              style={{
                position: 'absolute',
                backgroundColor: '#f9f9f9',
                padding: '5px 5px',
                borderRadius: '50%',
                zIndex: '1000',
              }}
            >
              <h6 style={{ margin: 0 }}>Or</h6>
            </div>
          </div>
          <div style={{ position: 'relative', alignSelf: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <PopModal
              isOpen={isModalOpen}
              type={modalType}
              confirmButtonText="OK"
              onConfirm={handleCancel}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CollegeResetPassword;